// extracted by mini-css-extract-plugin
module.exports = {"example":"Example-module--example--3VM2K","exampleDe":"Example-module--exampleDe--3e9hG","exampleItalic":"Example-module--exampleItalic--a52PT"};